import $ from 'jquery'

import 'blueimp-canvas-to-blob'
import 'blueimp-file-upload'

import csrf from './csrf'

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

class AudioTimer {
  constructor (element, audio) {
    this.lastTime = null
    this.element = element
    this.audio = audio
    this.date = new Date()
  }

  update () {
    var t = this.getTime()
    var ft = Math.floor(t)
    if (ft != this.lastTime) {
      this.lastTime = ft
      this.element.text(this.timeToString(t))
    }
    this.requestFrame()
  }

  requestFrame () {
    this.frameId = requestAnimationFrame(this.update.bind(this))
  }

  play () {
    this.lastTime = null
    this.date = new Date()
    this.stop()
    this.update()
  }

  stop () {
    cancelAnimationFrame(this.frameId)
  }

  setAudio (audio) {
    this.audio = audio
  }

  getTime () {
    if (this.audio) {
      var t = this.audio.getCurrentTime()
    } else {
      var t = (Date.now() - this.date) / 1000
    }
    return t
  }

  timeToString (seconds) {
    let s = Math.floor(seconds);
    let m = Math.floor(s / 60)
    s %= 60
    return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s)
  }
}

class Control {
  constructor(y) {
    this.element = $(y, ctx, yp)
    this.control = this.element.find('.speaker-control')
    this.yp = yp
    this.ctx = ctx
    this.nextF = null
    this.prevF = null
    this.acceptF = null

    this.audio = null

    this.input = this.control.find('input.upload-sound')
    this.prevButton = this.control.find('button.speaker-prev')
    this.nextButton = this.control.find('button.speaker-next')
    this.recordButton = this.control.find('button.start-record')
    this.stopButton = this.control.find('button.stop-record')
    this.playButton = this.control.find('button.play-sound')
    this.pauseButton = this.control.find('button.pause-sound')
    this.deleteButton = this.control.find('button.delete-sound')
    this.acceptButton = this.control.find('button.speaker-accept')
    this.positionText = this.control.find('.counter-text')

    this.recordTimer = new AudioTimer(this.control.find('.js_timer.recording'))
    this.playTimer = new AudioTimer(this.control.find('.js_timer.recorded-playing'))

    this.prevButton.click(this.prev.bind(this))
    this.nextButton.click(this.next.bind(this))
    this.recordButton.click(this.record.bind(this))
    this.stopButton.click(this.stop.bind(this))
    this.playButton.click(this.play.bind(this))
    this.pauseButton.click(this.pause.bind(this))
    this.deleteButton.click(this._delete.bind(this))
    this.acceptButton.click(this.accept.bind(this))

    this.uploadurl = this.control.data('upload-url')
    this.failure = 'Error uploading'
    if (this.uploadurl.indexOf('/') === 0) {
      this.uploadurl = this.ctx + this.uploadurl
    }
    if (this.control.data('failure')) {
      this.failure = this.control.data('failure')
    }

    this.initUpload()

    // console.log('speaker:using ctx [' + this.ctx + '] for the upload [' + this.uploadurl + ']')
    // console.log('speaker:using failure [' + this.failure + ']')
    this.initShow()
  }

  id () {
    return this.element.find('.item-id').data('value')
  }

  type () {
    return this.element.find('.item-exercise-exerciseType').data('value')
  }

  initUpload () {
    this.input.fileupload({
      type: 'POST',
      dataType: 'json',
      headers: csrf(),
      url: this.uploadurl,
      paramName: 'file',
      singleFileUploads: false,
      maxFileSize: 999000,
      maxNumberOfFiles: 1,
    }).
      on('fileuploaddone', this.fileuploaddone.bind(this)).
      on('fileuploadfail', this.fileuploadfail.bind(this))
  }

  fileuploaddone (e, data) {
    console.log('speaker::fileuploaddone', e, data, data.result)
    this.result = data.result.file
    this.audio = createAudio(data.files[0])
    this.setState('stopped')
    this.initUpload()
  }

  fileuploadfail (e, data) {
    console.log('speaker::fileuploadfail', e, data)
    this.result = null
    this.yp.addError(this.failure)
    this.setState('empty')
    this.initUpload()
  }

  setState (state) {
    this.state = state
    this.control.attr('class', 'speaker-control')
    this.control.addClass(state)
    if (state == 'empty') {
      this.recordButton.show()
      this.stopButton.hide()
      this.playButton.hide()
      this.pauseButton.hide()
      this.deleteButton.hide()
      this.acceptButton.hide()
    }
    if (state == 'recording') {
      this.recordButton.hide()
      this.stopButton.show()
      this.playButton.hide()
      this.pauseButton.hide()
      this.deleteButton.hide()
      this.acceptButton.hide()
    }
    if (state == 'stopped') {
      this.recordButton.hide()
      this.stopButton.hide()
      this.playButton.show()
      this.pauseButton.hide()
      this.deleteButton.show()
      this.acceptButton.show()
    }
    if (state == 'playing') {
      this.recordButton.hide()
      this.stopButton.hide()
      this.playButton.hide()
      this.pauseButton.show()
      this.deleteButton.show()
      this.acceptButton.show()
    }
  }

  noPrev() {
    this.prevButton.hide()
  }

  noNext() {
    this.nextButton.hide()
  }
  setPositionText(strPos, strTotal) {
    this.positionText.find('.current').text(strPos)
    this.positionText.find('.total').text(strTotal)
  }

  setNext(f) {
    this.nextF = f
  }

  setPrev(f) {
    this.prevF = f
  }

  setAccept(f) {
    this.acceptF = f
  }

  show () {
    this.element.show()
  }

  hide () {
    this.element.hide()
  }

  initShow () {
    this.element.hide()
    this.element.find('.fieldgroup.hidden').removeClass('hidden')
    this.setState('empty')
  }

  prev () {
    // console.log('speaker-prev')
    if (this.state == 'recording') {
      return;
    }
    if (this.prevF) {
      this.pause()
      this.prevF(this)
    }
  }

  next () {
    console.log('speaker-next')
    if (this.state == 'recording') {
      return;
    }
    if (this.nextF) {
      this.pause()
      this.nextF(this)
    }
  }

  record () {
    (async () => {
      // console.log('start-record')
      recorder = await recordAudio({
        channelCount: 1,
        autoGainControl: false,
        echoCancellation: false,
        noiseSuppression: false,
        sampleRate: 48000,
        sampleSize: 32,
        volume: 1.0,
      })
      recorder.start()
      this.recordTimer.play()
      this.setState('recording')
    })()
  }

  stop () {
    (async () => {
      // console.log('stop-record')
      const blob = await recorder.stop()
      let x = this.recordTimer.timeToString(this.recordTimer.getTime())
      this.recordTimer.stop()
      this.control.find('.js_timer.recorded-playing-total').text(x)

      recorder = null
      this.setState('stopped')
      this.input.fileupload('add', { files: [blob] })
    })()
  }

  play () {
    // console.log('play-sound')
    if (this.audio) {
      this.audio.play(this.setState.bind(this, 'stopped'))
      this.playTimer.setAudio(this.audio)
      this.playTimer.play()

      this.setState('playing')
    }
  }

  pause () {
    // console.log('pause-sound')
    if (this.audio) {
      this.audio.pause()
      this.setState('stopped')
    }
  }

  _delete () {
    // console.log('delete-sound')
    if (this.audio) {
      this.audio.pause()
      this.audio = null
      this.setState('empty')
    }
  }

  accept () {
    // console.log('speaker-accept')
    var _this = this
    $.ajax({
      url: this.ctx + '/y/item/' + this.id() + '/update_record?json',
      type: 'POST',
      dataType: 'json',
      data: { 'item.answer.mp3': this.result },
      headers: csrf(),
      success: function (data) {
        // console.log('success', data)
        _this.yp.showMessages(data)
        if (data.result == 'execute' && _this.acceptF) {
          _this.acceptF(_this)
        }
      },
      error: function (jqXHR, statusText, errorThrown) {
        // console.log('error', jqXHR, textStatus, errorThrown)
        _this.yp.addError(_this.failure)
      },
    })
  }
}

var recorder = null
const recordAudio = (x) => new Promise(resolve => {
  navigator.mediaDevices.getUserMedia({ audio: x })
    .then(stream => {
      const mediaRecorder = new MediaRecorder(stream)
      const audioChunks = []

      mediaRecorder.addEventListener('dataavailable', event => {
        audioChunks.push(event.data)
      })

      const start = () => {
        mediaRecorder.start()
      }

      const stop = () => new Promise(resolve => {
        mediaRecorder.addEventListener('stop', () => {
          resolve(new Blob(audioChunks))
        })

        mediaRecorder.stop()
      })

      const settings = () => {
        var s = {}
        s.mime = mediaRecorder.mimeType
        let audioTracks = stream.getAudioTracks()
        if (audioTracks.length) {
          return { ...s, ...audioTracks[0].getSettings() }
        } else {
          return {}
        }
      }

      resolve({ start, stop, settings })
    })
})

var createAudio = function (blob) {
  // console.log('SoundRecord::setAudio')
  var inner = null
  if (blob instanceof HTMLAudioElement) {
    inner = blob
  } else if (blob instanceof File) {
    inner = new Audio(URL.createObjectURL(blob))
  } else if (blob instanceof Blob) {
    inner = new Audio(URL.createObjectURL(blob))
  } else {
    console.log('SoundRecord::setAudio, unknown', blob, typeof blob, blob.constructor.name)
    return
  }

  var audio = {
    play: (x) => {
      inner.play()
      if (typeof x == 'function') {
        inner.addEventListener('ended', (event) => { x() })
      }
    },
    pause: () => {
      inner.pause()
    },
    getCurrentTime: () => inner.currentTime,
  }
  return audio
}

var defaults = {
  yp: undefined,
  failure: 'Error uploading',
}

export default {
  init: function (opts) {
    var D = $.extend({}, defaults, opts || {})
    D.control = []

    if (D.view == null) {
      return
    }
    const items = D.view.find('.entity-item')
    items.each(function (x, y) {
      var c = new Control(y, D.ctx, D.yp)
      D.control.push(c)
      c.setNext(function (e) {
        var ni = D.control.findIndex((x) => x.id() == e.id())

        // console.log('next', e.id(), ni)
        D.control[ni].hide()
        D.control[ni + 1].show()
      })
      c.setPrev(function (e) {
        var ni = D.control.findIndex((x) => x.id() == e.id())

        // console.log('prev', e.id(), ni)
        D.control[ni].hide()
        D.control[ni - 1].show()
      })
      c.setAccept(function (e) {
        var ni = D.control.findIndex((x) => x.id() == e.id())

        // console.log('accept', e.id(), ni)
        D.control[ni].hide()
        D.control.splice(ni, 1)
        if (ni == D.control.length) {
          ni--
        }
        updateTexts()
        if (D.control.length > 0) {
          D.control[ni].show()
          D.control[0].noPrev()
          D.control[D.control.length - 1].noNext()
        } else {
          D.view.find('.no-content').show()
        }
      })
    })
    updateTexts()
    console.log('speaker:init', D.control.length)
    if (D.control.length > 0) {
      D.control[0].show()
      D.control[0].noPrev()
      D.control[D.control.length - 1].noNext()
    } else {
      D.view.find('.no-content').show()
    }

    function updateTexts() {
      D.control.map((c, x) => {
        c.setPositionText(x + 1, D.control.length)
      })
    }
  },
}
